import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { BASE_URL, axiosInstance } from "../../Config";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";
import "@fancyapps/fancybox";

const UserList = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);

  const [dateFilter, setDateFilter] = useState("all");
  const limit = 10;

  const dateFilters = [
    { value: "all", label: "All Data" },
    { value: "7", label: "Last 7 Days" },
    { value: "30", label: "This Month" },
    { value: "180", label: "Last 6 Months" },
    { value: "365", label: "Last Year" },
  ];

  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm.trim());
    }, 500);

    return () => clearTimeout(t);
  }, [searchTerm]);

  useEffect(() => {
    fetchUsers(currentPage, searchTerm, dateFilter);
  }, [currentPage, debouncedSearchTerm, dateFilter]);

  const fetchUsers = async (page, search = "", filter = "all") => {
    setLoading(true)
    try {
      const response = await axiosInstance.get(
        `/getAllUsers?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}&dateFilter=${filter}`
      );
      if (response.data.success) {
        setUsers(response?.data?.body?.data || []);
        setTotalPages(response?.data?.body?.totalPages);
      } else {

      }
    } catch (error) {

    } finally {
      setLoading(false)
    }
  };


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleDateFilter = (value) => {
    setDateFilter(value);
    setCurrentPage(1);
  };

  const deleteUserHandler = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "green",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axiosInstance.delete(`/userDelete/${id}`);

        const response = await axiosInstance.get(
          `/getAllUsers?page=${currentPage}&limit=${limit}&search=${encodeURIComponent(
            debouncedSearchTerm
          )}&dateFilter=${dateFilter}`
        );

        if (response.data.success) {
          const newTotalPages = response?.data?.body?.totalPages;
          const newData = response?.data?.body?.data || [];

          if (newData.length === 0 && currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1);
          } else {
            setUsers(newData);
            setTotalPages(newTotalPages);
          }
        Swal.fire({
          title: "Deleted!",
          text: "User has been deleted successfully.",
          icon: "success",
          confirmButtonColor: "green",
        });

        }
      } catch (error) {
        // console.log("jjj",error)
        Swal.fire(
          "Error!",
          error.response?.data?.message || "Error deleting user",
          "error"
        );
      }
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    setStatusLoading(true)
    try {
      const newStatus = currentStatus === 0 ? 1 : 0;
      await axiosInstance.post("/userStatus", {
        id,
        status: newStatus,
      });

      setUsers(users.map(user =>
        user.id === id ? { ...user, status: newStatus } : user
      ));

      toast.success(`User status updated to ${newStatus == 1 ? "active" : "inactive"}.`);
    } catch (error) {
      toast.error("Failed to update status.");
    } finally {
      setStatusLoading(false)
    }
  };

  const handleViewDetails = (id) => {
    navigate(`/viewUser/${id}`)
  };

  const getCurrentFilterLabel = () => {
    const filter = dateFilters.find((f) => f.value === dateFilter);
    return filter ? filter.label : "All Data";
  };





  return (
    <>
      <div id="layout-wrapper">
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="title-box mb-3 pb-1">
                <h4 className="mb-0 page-title">User List</h4>
                <nav aria-label="breadcrumb" className="mt-1">
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard" className="new">
                        <i className="ri-home-4-fill me-1 new" /> Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/userlist" className="new">
                        Users
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      User Listings
                    </li>
                  </ol>
                </nav>
              </div>

              <div className="card">
                <div className="card-body cusbar">

                  <div className="card-head mb-3 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                      <div className="tbl-search position-relative me-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search.."
                          value={searchTerm}
                          onChange={handleSearchChange}
                        />
                        <i className="ri-search-line" />
                      </div>

                      <div className="dropdown tbl-drop">
                        <button
                          className="btn btn-light dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {getCurrentFilterLabel()}
                        </button>
                        <ul className="dropdown-menu">
                          {dateFilters.map((filter) => (
                            <li key={filter.value}>
                              <button
                                className="dropdown-item"
                                type="button"
                                onClick={() => handleDateFilter(filter.value)}
                              >
                                {filter.label}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>


                  </div>

                  <div className="table-responsive table-card border-top">
                    <div data-simplebar="" className="cus-scroll scmob pb-5">
                      <table className={`table table-centered cus-nowrap align-middle hltr ${(totalPages && totalPages > 1) ? "mb-0" : "mb-5"}`}>
                        <thead>
                          <tr>
                            <th>Sr no.</th>
                            <th>Image</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone number</th>
                            <th>Status</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users.length > 0 ? (
                            users.map((user, index) => (
                              <tr key={user.id}>
                                <td>{(currentPage - 1) * limit + index + 1}</td>
                                <td>
                                  {user?.image ? (
                                    <a
                                      href={`${BASE_URL}${user?.image}`}
                                      data-fancybox="user-gallery"
                                      data-caption={user?.name || "User Image"}
                                    >
                                      <img
                                        src={`${BASE_URL}${user?.image}`}
                                        alt="User"
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          borderRadius: "50%",
                                          cursor: "pointer",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </a>
                                  ) : (
                                    <img
                                      src={"assets/images/user.png"}
                                      alt="User"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        cursor: "pointer",
                                        objectFit: "cover",
                                      }}
                                    />
                                  )}
                                </td>
                                <td>{user?.name || "N/A"}</td>
                                <td>{user?.email || "N/A"}</td>
                                <td>
                                  {user?.country_code} {user?.phone_number|| "N/A"}
                                </td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      disabled={statusLoading}
                                      id={`toggleStatus${user?.id}`}
                                      checked={user?.status == 1}
                                      onChange={() =>
                                        toggleStatus(user?.id, user?.status)
                                      }
                                      style={{
                                        backgroundColor:
                                          user?.status == 1
                                            ? "#963F02"
                                            : "lightgray",
                                        borderColor:
                                          user?.status == 1
                                            ? "#963F02"
                                            : "lightgray",
                                        cursor: "pointer"
                                      }}
                                    />
                                  </div>
                                </td>
                               
                                <td>
                                  <div className="d-flex justify-content-end">

                                    <button
                                      type="button"
                                      className="btn btn-soft-primary px-2 btn-sm me-1"
                                      onClick={() => handleViewDetails(user?.id)}
                                    >
                                      <i className="ri-eye-fill font-size-16"></i>
                                    </button>

                                    <button
                                      onClick={() => deleteUserHandler(user?.id)}
                                      className="btn btn-soft-danger px-2 btn-sm"
                                      style={{
                                        backgroundColor: "#ea5455",
                                        borderColor: "#ea5455",
                                        color: "#fff",
                                      }}
                                      title="Delete User"
                                    >
                                      <i className="ri-delete-bin-line font-size-16"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            !loading && <tr>
                              <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                                No users found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {totalPages && totalPages > 1 ?
                        <div className="d-flex justify-content-center align-items-center mt-3">
                          <Stack spacing={2} className="d-flex justify-content-center mt-3">
                            <Pagination
                              count={totalPages}
                              page={currentPage}
                              onChange={handlePageChange}
                              color="error"
                            />
                          </Stack>
                        </div>
                        : null}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {(loading  || statusLoading) && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <div
            className="spinner-border"
            role="status"
            style={{ width: "50px", height: "50px", color: "#963F02" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
    </>
  );
};

export default UserList;